import { render, staticRenderFns } from "./TestException.vue?vue&type=template&id=25ee5460"
import script from "./TestException.vue?vue&type=script&lang=ts"
export * from "./TestException.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports